import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/')({
  component: Index,
  loader: async () => {
    // Rredirect to the organizations list
    throw redirect({
      to: '/orgs',
    })
  },
})

function Index() {
  // This component won't render due to the redirects in the loader
  return (
    <div className="p-2">
      <h3>Redirecting to organization list...</h3>
    </div>
  )
}
